import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config/gameConfig';
import { THEME } from '@/config/theme';
import { drawArcadeBackground, addTextGlow } from '@/utils/arcadeBackground';
import { createBackButton } from '@/ui/buttons';
import { setDiscordIdlePresence } from '@/discord';

export class CreditsScene extends Phaser.Scene {
  constructor() {
    super({ key: 'CreditsScene' });
  }

  create(): void {
    // Fade in
    this.cameras.main.fadeIn(300, 5, 7, 22);

    // Discord Activity presence (menus/idle)
    setDiscordIdlePresence();

    // Arcade background
    drawArcadeBackground(this);

    // Title with glow (positioned above panel)
    const panelY = GAME_HEIGHT / 2 + 30;
    const panelHeight = 420;
    const title = this.add.text(GAME_WIDTH / 2, panelY - panelHeight / 2 - 40, 'CREDITS', {
      fontFamily: THEME.fonts.heading,
      fontSize: THEME.sizes.title,
      color: THEME.colors.cyan,
    }).setOrigin(0.5);
    addTextGlow(title, THEME.colors.cyan, 15);

    // Background panel
    const panel = this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 30, 600, 420, THEME.colors.backgroundLightHex, 0.9);
    panel.setStrokeStyle(3, THEME.colors.magentaHex);

    // Credits list
    const credits = [
      'Serge Knystautas',
      'tyy34',
      'Yerlan Nurtaev (SkyToneStudio)',
      'Tumisu (pixvalen)',
      'flutie8211 (Vicki Hamilton)',
      'TheDigitalArtist (Pete Linforth)',
      // Telegraph icon: Morse code icons created by Freepik - Flaticon
      // https://www.flaticon.com/free-icons/morse-code
      'Freepik - Flaticon',
    ];

    const startY = 200;
    const lineSpacing = 60;

    credits.forEach((name, index) => {
      this.add.text(GAME_WIDTH / 2, startY + index * lineSpacing, name, {
        fontFamily: THEME.fonts.pixel,
        fontSize: THEME.sizes.bodyLarge,
        color: THEME.colors.text,
        stroke: THEME.stroke.color,
        strokeThickness: THEME.stroke.thicknessThin,
      }).setOrigin(0.5);
    });

    // Back button
    createBackButton(this, {
      x: 100,
      y: 60,
      onClick: () => {
        this.transitionTo('MenuScene');
      },
    });

    // Keyboard navigation: Esc, Enter, or Space to go back
    this.input.keyboard?.on('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
        this.transitionTo('MenuScene');
      }
    });
  }

  private transitionTo(scene: string, data?: object): void {
    this.cameras.main.fadeOut(200, 5, 7, 22);
    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.start(scene, data);
    });
  }
}
